<template>
    <div>
        <Header></Header>
        <main id="content" role="main">
            <div class="position-relative bg-primary overflow-hidden">
                <div class="
            container
            position-relative
            z-index-2
            space-top-3 space-top-md-4 space-bottom-3 space-bottom-md-4
          ">
                    <div class="w-md-80 w-xl-60 text-center mx-md-auto">
                        <div class="mb-7">
                            <h1 class="display-4 text-white mb-4">万物云CSM （正式版）</h1>
                            <p class="lead text-white mb-4">
                                功能强大的企业网站程序，快速安全部署
                            </p>
                        </div>
                        <router-link class="btn btn-light btn-wide transition-3d-hover" to="/contact">客户购买咨询</router-link>
                        <!-- <a class="btn text-white" href="#"
              >申请账户<i class="fas fa-angle-right fa-sm ml-1"></i
            ></a> -->
                    </div>
                </div>

                <!-- SVG Shapes -->
                <figure class="position-absolute top-0 left-0 w-60">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1246 1078">
                        <g opacity=".4">
                            <linearGradient id="doubleEllipseTopLeftID1" gradientUnits="userSpaceOnUse" x1="2073.5078" y1="1.7251" x2="2273.4375" y2="1135.5818" gradientTransform="matrix(-1 0 0 1 2600 0)">
                                <stop class="stop-color-primary-lighter" offset="0.4976" style="stop-color: #19a0ff" />
                                <stop class="stop-color-primary" offset="1" style="stop-color: #377dff" />
                            </linearGradient>
                            <polygon fill="url(#doubleEllipseTopLeftID1)" points="519.8,0.6 0,0.6 0,1078 863.4,1078   " />
                            <linearGradient id="doubleEllipseTopLeftID2" gradientUnits="userSpaceOnUse" x1="1717.1648" y1="3.779560e-05" x2="1717.1648" y2="644.0417" gradientTransform="matrix(-1 0 0 1 2600 0)">
                                <stop class="stop-color-primary-lighter" offset="1.577052e-06" style="stop-color: #19a0ff" />
                                <stop class="stop-color-primary" offset="1" style="stop-color: #377dff" />
                            </linearGradient>
                            <polygon fill="url(#doubleEllipseTopLeftID2)" points="519.7,0 1039.4,0.6 1246,639.1 725.2,644   " />
                        </g>
                    </svg>
                </figure>
                <figure class="position-absolute right-0 bottom-0 left-0 mb-n1">
                    <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">
                        <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z" />
                    </svg>
                </figure>
                <!-- End SVG Shapes -->
            </div>
            <div class="border-bottom">
                <div class="container space-1  space-top-md-0">
                    <div class="w-md-100 text-center mx-md-auto mb-5 mb-md-9">
                        <h2 class="h1">典型客户</h2>
                        <p>众多企业选择我们提供的技术开发服务，私有部署，功能强大。</p>
                    </div>

                    <div class="w-lg-80 mx-lg-auto">
                        <div class="row justify-content-center">
                            <div class="col-4 col-sm-3 col-md my-2">
                                <img v-if="uplist.one" class="max-w-11rem max-w-md-13rem mx-auto" :src="getImgUrl(uplist.one)" alt="Image Description" />
                            </div>
                            <div class="col-4 col-sm-3 col-md my-2">
                                <img v-if="uplist.two" class="max-w-11rem max-w-md-13rem mx-auto" :src="getImgUrl(uplist.two)" alt="Image Description" />
                            </div>
                            <div class="col-4 col-sm-3 col-md my-2">
                                <img v-if="uplist.three" class="max-w-11rem max-w-md-13rem mx-auto" :src="getImgUrl(uplist.three)" alt="Image Description" />
                            </div>
                            <div class="col-4 col-sm-3 col-md my-2">
                                <img v-if="uplist.four" class="max-w-11rem max-w-md-13rem mx-auto" :src="getImgUrl(uplist.four)" alt="Image Description" />
                            </div>
                            <div class="col-4 col-sm-3 col-md my-2">
                                <img v-if="uplist.five" class="max-w-11rem max-w-md-13rem mx-auto" :src="getImgUrl(uplist.five)" alt="Image Description" />
                            </div>
                            <div class="col-4 col-sm-3 col-md my-2">
                                <img v-if="uplist.six" class="max-w-11rem max-w-md-13rem mx-auto" :src="getImgUrl(uplist.six)" alt="Image Description" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container space-top-2 space-top-lg-3">
                <div class="w-md-100 text-center mx-md-auto mb-5 mb-md-9">
                    <h2 class="h1">核心功能</h2>
                    <p>六大核心功能满足企业经营需求，面向未来，可扩展性强。</p>
                </div>
                <div class="row justify-content-lg-center">
                    <div class="col-md-6 col-lg-5 mb-3 mb-md-7" v-for="item in ywList" :key="item.contentId">
                        <!-- Icon Blocks -->
                        <div class="media pr-lg-5" data-aos="fade-up">
                            <figure class="w-100 max-w-8rem mr-4">
                                <img class="img-fluid" :src="getImgUrl(item.fileId)" alt="SVG" />
                            </figure>
                            <div class="media-body">
                                <h4>{{item.title}}</h4>
                                <p v-html="item.content">

                                </p>
                            </div>
                        </div>
                        <!-- End Icon Blocks -->
                    </div>
                </div>
            </div>
            <!-- 核心产品与服务 -->
            <div class="container space-2">
                <div class="row justify-content-lg-between">
                    <div class="col-lg-5 order-lg-2 pl-lg-0">
                        <div v-if="hximg" class="bg-img-hero h-90 min-h-450rem rounded" :style="'background-image: url('+imgsrc + hximg+');'">
                        </div>
                    </div>
                    <div class="col-lg-6 order-lg-1 text-center">

                        <div class="pt-1 ">
                            <div class="mb-5 mb-md-7">
                                <h2 class="divider divider-text">{{ hxtitle }}</h2>
                                <h2 class="h">{{ hxDEVS.title }}</h2>
                                <p>{{ hxDEVS.subtitle }}</p>
                                <p v-html="hxDEVS.content"> </p>
                            </div>

                            <div class="row">
                                <div class="col-6 mb-3 mb-md-5" v-for="(item, index) in hxlist" :key="index">
                                    <div class="pr-lg-hxlist">
                                        <span class="js-counter h4 text-primary">{{ item.title }}</span>
                                        <p>{{ item.subtitle }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- End 核心产品与服务 -->
            <div class="container space-top-2 space-top-lg-3">
                <div class="w-md-100 text-center mx-md-auto mb-5 mb-md-9">
                    <h2 class="h1">{{ bushutitle }}</h2>
                    <p>{{ bushusubtitle }}</p>
                </div>
                <div class="row mx-n2 mb-5 mb-md-9">
                    <div class="col-sm-6 col-lg-3 px-2 mb-3 mb-lg-0" v-for="item in contentList1" :key="item.contentId">
                        <!-- Card -->
                        <a class="card h-100 transition-3d-hover" style="cursor:pointer;color:#0052ea" @click="skip(item.contentId)">
                            <img class="card-img-top" :src="getImgUrl(item.imgsrc)" alt="Image Description" />
                            <div class="card-body">
                                <span class="d-block small font-weight-bold text-cap mb-2">解决方案</span>
                                <h5 class="mb-0">{{item.title}}</h5>
                            </div>
                        </a>
                        <!-- End Card -->
                    </div>
                </div>
            </div>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import '@/assets/vendor/jquery/dist/jquery.min.js' //1
import '@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js' //2
import 'bootstrap/dist/js/bootstrap.bundle.min.js' //3

import '@/assets/vendor/font-awesome/css/all.min.css' //11
import '@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.css' //12
import '@/assets/vendor/aos/dist/aos.css' //13
import '@/assets/css/theme.css'
import '@/assets/vendor/hs-header/dist/hs-header.min.js' //4
import '@/assets/vendor/hs-go-to/dist/hs-go-to.min.js' //5
import '@/assets/vendor/hs-unfold/dist/hs-unfold.min.js' //6
import '@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.js' //7
import '@/assets/vendor/hs-toggle-switch/dist/hs-toggle-switch.min.js' //8
// import "@/assets/vendor/aos/dist/aos.js"//9.
import AOS from 'aos'

import '@/assets/js/hs.core.js' //10

import Header from '../components/header.vue'
import Footer from '../components/footer.vue'
import { getsy, getsycolumn, getPostDetail, getsyres } from '../request/index'
export default {
    components: {
        Header,
        Footer,
    },
    data() {
        return {
            bushutitle: '', // 部署方案
            bushusubtitle: '', // 部署子标题
            imgsrc: process.env.NODE_URL + 'api/files/getFileStream?fileId=',
            uplist: {
                one: null,
                two: null,
                three: null,
                four: null,
                five: null,
                six: null,
            }, // 6图
            ywList: [],
            collist: [],
            contentList: [],
            contentList1: [],
            hxtitle: '', // 核心标题
            hxDEVS: [], // 核心产品DEVS?
            hxlist:[],
            hximg:null
        }
    },
    created() {
        this.getMore()
        getsycolumn(0).then((res) => {
            let arr = res.data
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].type == 'DEVS 2.0') {
                    getsycolumn(arr[i].columnId).then((res) => {
                        let arr1 = res.data
                        for (let i = 0; i < arr1.length; i++) {
                            if (arr1[i].type == '六图') {
                                this.getimg(arr1[i].columnId)
                            }
                            if (arr1[i].type == '业务核心') {
                                this.getimg(arr1[i].columnId, true)
                            }
                            if (arr1[i].type == '部署方案') {
                                this.bushutitle = arr1[i].title
                                this.bushusubtitle = arr1[i].subtitle
                            }
                            if (arr1[i].type == '核心产品与服务') {
                                getsy(arr1[i].columnId).then((Res) => {
                                    this.hxtitle = arr1[i].title
                                    this.getzy(Res.data.content[0].contentId)
                                    this.hxDEVS = Res.data.content[0]
                                    this.hxlist = Res.data.content
                                    this.hxlist.splice(0, 1)
                                })
                            }
                        }
                    })
                }
            }
        })
    },
    methods: {
        getimg(a, b) {
            getsy(a).then((res) => {
                let arr = res.data.content
                if (b) {
                    arr.forEach((item) => {
                        this.getzy(item.contentId, item, true)
                    })
                } else {
                    this.getzy(arr[0].contentId)
                }
            })
        },
        getzy(a, b, c) {
            getsyres(a).then((res) => {
                let arr = res.data
                if (c) {
                    if (arr && arr.length > 0) {
                        arr.forEach((item) => {
                            if (item.keystring == '业务图') {
                                b.fileId = item.fileId
                                this.ywList.push(b)
                            }
                        })
                    }
                } else {
                    for (let i = 0; i < arr.length; i++) {
                        if (arr[i].keystring == '图一') {
                            this.uplist.one = arr[i].fileId
                        }
                        if (arr[i].keystring == '图二') {
                            this.uplist.two = arr[i].fileId
                        }
                        if (arr[i].keystring == '图三') {
                            this.uplist.three = arr[i].fileId
                        }
                        if (arr[i].keystring == '图四') {
                            this.uplist.four = arr[i].fileId
                        }
                        if (arr[i].keystring == '图五') {
                            this.uplist.five = arr[i].fileId
                        }
                        if (arr[i].keystring == '图六') {
                            this.uplist.six = arr[i].fileId
                        }
                        if (arr[i].keystring == '核心') {
                            this.hximg= arr[i].fileId
                        }
                    }
                }
            })
        },
        // 图片地址
        getImgUrl(id) {
            return process.env.NODE_URL + 'api/files/getFileStream?fileId=' + id
        },
        getMore() {
            getsycolumn(0).then((res) => {
                let arr = res.data
                arr.forEach((item) => {
                    if (item.type == '行业方案') {
                        this.collist.push(item.columnId)
                        getsycolumn(item.columnId).then((hs) => {
                            let ar1 = hs.data
                            ar1.forEach((ts) => {
                                this.collist.push(ts.columnId)
                            })
                            this.getMoreContent(this.collist)
                        })
                    }
                })
            })
        },
        // 通过栏目id查询内容
        getMoreContent(arr) {
            getPostDetail(arr).then((res) => {
                this.contentList = res.data
                let z = 0
                this.contentList.forEach((item, i) => {
                    if (z >= 4) {
                        return
                    } else {
                        z = z + 1
                        this.getImgResouce(item, item.contentId)
                    }
                })
            })
        },
        // 通过内容id获取资源
        getImgResouce(obj, id) {
            getsyres(id).then((res) => {
                let arr = res.data
                if (arr && arr.length > 0) {
                    arr.forEach((hs) => {
                        if (hs.keystring == '封面') {
                            obj.imgsrc = hs.fileId
                            this.contentList1.push(obj)
                        }
                    })
                }
            })
        },
        skip(id) {
            this.detalContent = null
            this.contentList1 = []
            this.contentList = []
            this.$router.push({ path: '/plan', query: { contentId: id } })
        },
    },
    mounted() {
        // window.addEventListener("scroll", this.handleScroll);
        $(document).ready(function () {
            //   console.log("ccccc",HSHeader)
            //   var header = new HSHeader($("#header")).init();

            // initialization of mega menu
            var megaMenu = new HSMegaMenu($('.js-mega-menu'), {
                desktop: {
                    position: 'left',
                },
            }).init()

            // initialization of unfold
            var unfold = new HSUnfold('.js-hs-unfold-invoker').init()

            // initialization of fancybox
            $('.js-fancybox').each(function () {
                var fancybox = $.HSCore.components.HSFancyBox.init($(this))
            })

            // initialization of circles
            $('.js-circle').each(function () {
                var circle = $.HSCore.components.HSCircles.init($(this))
            })

            //initialization of aos
            AOS.init({
                duration: 650,
                once: true,
            })
            // if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) document.write('<script src="@/assets/vendor/polifills.js"><\/script>');
            // initialization of go to
            $('.js-go-to').each(function () {
                var goTo = new HSGoTo($(this)).init()
            })
            $('.js-counter').each(function () {
                var counter = new HSCounter($(this)).init()
            })
        })
    },
}
</script>

<style scoped>
.mb-md-9 h2 {
    font-size: 2.5rem !important;
    font-weight: 600;
    line-height: 1.4;
}
.mb-md-9 p {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.6;
    color: #677788;
}
.btn {
    display: inline-block;
    font-weight: 600;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    border: 0.0625rem solid transparent;
    padding: 0.75rem 1rem;
    font-size: 1rem;
    line-height: 1.6;
    border-radius: 0.3125rem;
}
.media-body h4 {
    font-size: 1.125rem;
    margin-bottom: 0.5rem;
    font-weight: 600;
    line-height: 1.4;
}
.media-body p {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.6;
    color: #677788;
    text-align: left;
}
.card-body h5 {
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.4;
}
a {
    text-decoration: none;
}
.mb-md-7 {
    margin-bottom: 3rem !important;
}
.pr-lg-5 {
    padding: 0 15px !important;
}
.space-top-lg-3 {
    padding-top: 5rem !important;
}
</style>


// WEBPACK FOOTER //
// src/view/devs.vue